import { render, staticRenderFns } from "./marks-list.vue?vue&type=template&id=48ac62f7&scoped=true&"
import script from "./marks-list.vue?vue&type=script&lang=js&"
export * from "./marks-list.vue?vue&type=script&lang=js&"
import style0 from "./marks-list.vue?vue&type=style&index=0&id=48ac62f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac62f7",
  null
  
)

export default component.exports